function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link'
// NOTE: using a patched version to solve a problem where the wrong authorization headers are being sent
import { createSubscriptionHandshakeLink } from './realtime-subscription-handshake-link-patch/lib';
import { AUTH_TYPE, createAuthLink } from 'aws-appsync-auth-link';
import { setContext } from '@apollo/client/link/context';
import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { iam } from '../profile/access';
var client = {};
export default (function (appsyncUrl) {
  var typePolicies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _iam = iam(),
    getAuthSession = _iam.getAuthSession,
    getJWTToken = _iam.getJWTToken,
    getTempAWSCreds = _iam.getTempAWSCreds;
  var headers = setContext(function (request, _ref) {
    var headers = _ref.headers;
    return {
      headers: _objectSpread(_objectSpread({}, headers), {}, {
        'x-cb-catapult-authorization-token': getJWTToken(),
        'x-cb-catapult-authentication-token': getAuthSession().sessionId
      })
    };
  });
  var appsyncConfig = {
    url: appsyncUrl,
    region: 'us-east-1',
    auth: {
      type: AUTH_TYPE.AWS_IAM,
      credentials: function credentials() {
        return getTempAWSCreds('apfym');
      }
    }
  };
  var appsyncLink = new ApolloLink.from([createAuthLink(_objectSpread(_objectSpread({}, appsyncConfig), {}, {
    disableOffline: true
  })), createSubscriptionHandshakeLink(appsyncConfig)]);
  if (!client[appsyncUrl]) client[appsyncUrl] = new ApolloClient({
    link: headers.concat(appsyncLink),
    cache: new InMemoryCache({
      typePolicies: _objectSpread({
        teacherRegistration: {
          keyFields: ['personId']
        },
        studentRegistration: {
          merge: true
        }
      }, typePolicies)
    })
  });
  return client[appsyncUrl];
});